import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { crmApi } from '@/app/crmApi';
import { addressesApi } from '@/features/addresses/addressesApi';
import appealsSelectionSlice from '@/features/appeals/appealsSelectionSlice';
import authSlice from '@/features/auth/authSlice';
import { biDashboardsApi } from '@/features/biDashboards/biDashboardsApi';
import { departmentsApi } from '@/features/departments';
import { employeePositionApi } from '@/features/employeePositions';
import { employeesApi } from '@/features/employees';
import { mainOrganizationApi } from '@/features/mainOrganization';
import { organizationsApi } from '@/features/organizations';
import { rolesApi } from '@/features/roles';
import { servicesApi } from '@/features/services/servicesApi';
import { subdivisionsApi } from '@/features/subdivisions';
import uiSlice from '@/features/ui/uiSlice';

const rootReducer = combineReducers({
  [crmApi.reducerPath]: crmApi.reducer,
  [uiSlice.name]: uiSlice.reducer,
  [authSlice.name]: authSlice.reducer,
  [appealsSelectionSlice.name]: appealsSelectionSlice.reducer,
  [servicesApi.reducerPath]: servicesApi.reducer,
  [addressesApi.reducerPath]: addressesApi.reducer,
  [organizationsApi.reducerPath]: organizationsApi.reducer,
  [employeesApi.reducerPath]: employeesApi.reducer,
  [subdivisionsApi.reducerPath]: subdivisionsApi.reducer,
  [departmentsApi.reducerPath]: departmentsApi.reducer,
  [employeePositionApi.reducerPath]: employeePositionApi.reducer,
  [mainOrganizationApi.reducerPath]: employeePositionApi.reducer,
  [rolesApi.reducerPath]: rolesApi.reducer,
  [biDashboardsApi.reducerPath]: biDashboardsApi.reducer,
});

const middlewares = [
  crmApi.middleware,
  servicesApi.middleware,
  addressesApi.middleware,
  employeesApi.middleware,
  biDashboardsApi.middleware,
  organizationsApi.middleware,
  subdivisionsApi.middleware,
  departmentsApi.middleware,
  employeePositionApi.middleware,
  mainOrganizationApi.middleware,
  rolesApi.middleware,
];

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(middlewares),
});

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
